<template>
	<div id="app" v-if="$store.getters.filmqueryvo">
		<navbar :to="'/film'" />
		
		<div class="containner mt-20 text-md">
			<div class="px-20 py-10 rounded box-shadow">
				
				<div class="flex item-start py-10 border-bottom">
					<div class="w-5 gray px-10 py-5 mx-5 filter-left text-right">类型：</div>
					<div class="w-95 flex wrap filter-right">
						<div class="px-10 py-5 dark hand rounded option mx-5"
							@click="category_clicked(null)"
							:class="{'active':routeQuery.cateId == null}">全部</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 hover-red"
							v-for="category of $store.getters.filmqueryvo.categories"
							:key="category.cateId"
							@click="category_clicked(category.cateId)"
							:class="{'active':routeQuery.cateId == category.cateId}">
							{{category.cateName}}
						</div>
					</div>
				</div>
				
				
				<div class="flex item-start py-10 border-bottom">
					<div class="w-5 gray px-10 py-5 mx-5 filter-left text-right">区域：</div>
					<div class="w-95 flex wrap filter-right">
						<div class="px-10 py-5 dark hand rounded option mx-5 "
							@click="Region_clicked(null)"
							:class="{'active':routeQuery.regionId == null}">全部</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 hover-red"
							v-for="region of $store.getters.filmqueryvo.filmRegions"
							:key="region.filmReId"
							@click="Region_clicked(region.filmReId)"
							:class="{'active':routeQuery.regionId == region.filmReId}">{{region.filmReName}}</div>
					</div>
				</div>
				
				
				<div class="flex item-start py-10">
					<div class="w-5 gray px-10 py-5 mx-5 filter-left text-right">年代：</div>
					<div class="w-95 flex wrap filter-right">
						<div class="px-10 py-5 dark hand rounded option mx-5 "
							@click="year_clicked(null)"
							:class="{'active':routeQuery.years == null}">全部</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 hover-red"
							v-for="year of years"
							:key="year.yid"
							@click="year_clicked(year.year)"
							:class="{'active':routeQuery.years == year.year}">{{year.year}}</div>
					</div>
				</div>
				
				
			
			</div>
		</div>
		
		<div class="containner mt-20 flex item-start wrap">
			<div v-for="film of $store.getters.filmqueryvo.films"
			:key="film.filmId" 
			@click="film_click(film.filmId)"
			class="film mx-10 my-10 px-10 py-10 rounded box-shadow hand hover-box-shadow-blue">
				<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+film.filmAvat" class="w-100"/>
				<div class="flex item-end justify-between mt-5">
					<div class="dark text-sm">{{film.filmName.length > 9 ? film.filmName.substr(0,9)+'...' : film.filmName}}</div>
					<div v-if="film.filmPraise" class="red text-xl weight">{{film.filmPraise}}</div>
					<div v-if="!film.filmPraise" class="red text-xl weight">暂无</div>
				</div>
			</div>
		</div>

		<div v-if="$store.getters.filmqueryvo.bo">
			<page :totalpage="$store.getters.filmqueryvo.bo.totalPage" @parentClick="pageEvent"/>
		</div>
	
		<foot />

	</div>
</template>

<script>
	
	import navbar from '@/components/navbar.vue'
	import foot from '@/components/foot.vue'
	import page from '@/components/page.vue'
	
	export default {
		data () {
			return {
				years: [
					{year: '2021', yid: 1},
					{year: '2020', yid: 2},
					{year: '2019', yid: 3},
					{year: '2018', yid: 4},
					{year: '2017', yid: 5},
					{year: '2016', yid: 6},
					{year: '2015', yid: 7},
					{year: '2014', yid: 8},
					{year: '2013', yid: 9},
					{year: '2012', yid: 10},
					{year: '2011', yid: 11},
					{year: '2010', yid: 12},
					{year: '早年',  yid: 13}
				],
				//参数对象
				routeQuery: {
					currentIndex: 1,
					totalRecord: 0,
					totalPage: 0,
					orderCol: null,
					orderDir: null,
					cateId: null,
					regionId: null,
					years: null
				}
			}
		},
		methods: {
			year_clicked (yearId) {
				this.routeQuery.years = yearId
				this.handFilter(this.routeQuery)
			},
			Region_clicked (regionId) {
				this.routeQuery.regionId = regionId
				this.handFilter(this.routeQuery)
			},
			category_clicked (cateId) {
				this.routeQuery.cateId = cateId
				this.handFilter(this.routeQuery)
			},
			loads () {
				console.log(this.$route.query)
				this.$store.dispatch('actFilmloads', {
					payload: this.routeQuery
					
				})
			},
			handFilter (routequery) {
				this.$router.push({
					path: '/film',
					query: routequery
				})
			},
			film_click (filmId) {
				this.$router.push({
					path: `/film/${filmId}`
				})
			},
			pageEvent (event) {
				this.routeQuery.currentIndex = event
				this.handFilter(this.routeQuery)
			}
		},
		watch: {
		   "$route": "loads"
		},
		mounted () {
			this.loads()
			
		},
		components:{
			navbar,
			foot,
			page
		}
		
	}
</script>

<style>
	.option.active{background-color: #e1251b; color: #fff;}
</style>
